"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var ramda_1 = require("ramda");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var reducers = {
    accessToken: api_1.createCustomModuleReducer((_a = {},
        _a[constants_1.SET_ACCESS_TOKEN] = function (state, action) {
            return action.payload;
        },
        _a), null),
    profile: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_PROFILE,
        onSuccess: api_1.createApiOnSuccessReducer(function (data, action) { return (__assign(__assign({}, data), action.payload)); }),
    }, {}),
    authError: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SPOTIFY_UNAUTHORIZED_ERROR] = function (state, action) {
            return action.payload;
        },
        _b), null),
    albumsById: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_BRAND_ALBUMS,
        onSuccess: api_1.createApiOnSuccessReducer(function (data, action) {
            var _a;
            var isShow = action.meta.isShow;
            var brand = action.payload[isShow ? 'show' : 'movie'];
            var sountracks = {};
            if (brand) {
                if (isShow) {
                    brand === null || brand === void 0 ? void 0 : brand.seasons.forEach(function (season) {
                        var _a;
                        sountracks[(_a = season === null || season === void 0 ? void 0 : season.soundtrack) === null || _a === void 0 ? void 0 : _a.id] = season === null || season === void 0 ? void 0 : season.soundtrack;
                    });
                }
                else {
                    sountracks[(_a = brand === null || brand === void 0 ? void 0 : brand.soundtrack) === null || _a === void 0 ? void 0 : _a.id] = brand === null || brand === void 0 ? void 0 : brand.soundtrack;
                }
            }
            return __assign(__assign({}, data), sountracks);
        }),
    }, {}),
    albumsSavedById: api_1.createApiModuleReducer({
        actionType: constants_1.FETCH_IS_SAVED_ALBUM,
        onSuccess: api_1.createApiOnSuccessReducer(function (data, action) {
            var _a;
            return __assign(__assign({}, data), (_a = {}, _a[action.meta.albumId] = ramda_1.head(action.payload), _a));
        }),
    }, {}),
    playerState: api_1.createCustomModuleReducer(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_PLAYER_STATE,
        onSuccess: api_1.createApiOnSuccessReducer(function (data, action) {
            var _a;
            // This condition has been updated to make rewind functionality
            // smoother and prevent progress bar from huge jumps that look bad
            if (Math.abs(((_a = action.payload) === null || _a === void 0 ? void 0 : _a.progress_ms) - data.lastSeekTime) < 6000) {
                return data;
            }
            return __assign(__assign({}, data), { player: action.payload });
        }),
    })), (_c = {}, _c[constants_1.SET_PLAYBACK_SEEK_TIME] = function (state, action) {
        return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), { lastSeekTime: action.payload }) });
    }, _c)), api_1.createApiInitialState({ player: null, lastSeekTime: 0 })),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map